angular.module('billing').config(['AppRoutesProvider', '$stateProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'billing' };

        var appRoutes = {
            'billing': {
                state: 'navigationBilling',
                route: '/navigationBilling',
                portalSettings: portalSettings
            },
            'paymentOptions': {
                state: 'paymentOptions',
                route: '/paymentOptions/:amount/:merchantId?financialCenterUid',
                portalSettings: portalSettings
            },
            'paymentFromConsent': {
                state: 'paymentOptions.paymentFromConsent',
                route: '/paymentFromConsent/:consentId',
                portalSettings: portalSettings
            },
            'paymentFromNewCard': {
                state: 'paymentOptions.paymentFromNewCard',
                route: '/paymentFromNewCard',
                portalSettings: portalSettings
            },
            'transactionComplete': {
                state: 'transactionComplete',
                route: '/transactionComplete/',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: true
                }
            },
            'paymentSummary': {
                state: 'paymentSummary',
                route: '/paymentSummary/:txId',
                portalSettings: portalSettings
            },
            //statements only routes//
            'paymentStatementsOnly': {
                state: 'paymentStatementsOnly',
                route: '/paymentStatementsOnly',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: false
                }
            },
            'paymentFromNewCardStatementsOnly': {
                state: 'paymentOptionsStatementsOnly.paymentFromNewCardStatementsOnly',
                route: '/paymentFromNewCardStatementsOnly',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: false
                }
            },
            'paymentOptionsStatementsOnly': {
                state: 'paymentOptionsStatementsOnly',
                route: '/paymentOptionsStatementsOnly/:amount/:merchantId?financialCenterUid',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: false
                }
            },
            'paymentFromConsentStatementsOnly': {
                state: 'paymentOptionsStatementsOnly.paymentFromConsentStatementsOnly',
                route: '/paymentFromConsentStatementsOnly/:consentId',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: false
                }
            },
            'paymentSummaryStatementsOnly': {
                state: 'paymentSummaryStatementsOnly',
                route: '/paymentSummaryStatementsOnly/:txId',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: false
                }
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.billing.state, {
                url: appRoutes.billing.route,
                templateUrl: '/billing/views/billing.html',
                controller: 'BillingCtrl',
                description: '/Billing',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Billing'); }
                }
            })
            .state(appRoutes.paymentOptions.state, {
                url: appRoutes.paymentOptions.route,
                templateUrl: '/billing/views/paymentOptions.html',
                controller: 'PaymentOptionsCtrl',
                description: '/Billing',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Make A Payment'); }
                }
            })
            .state(appRoutes.paymentFromConsent.state, {
                url: appRoutes.paymentFromConsent.route,
                templateUrl: '/billing/views/partials/paymentFromConsent.html',
                controller: 'PaymentFromConsentCtrl',
                description: '/Billing'
            })
            .state(appRoutes.paymentFromNewCard.state, {
                url: appRoutes.paymentFromNewCard.route,
                templateUrl: '/billing/views/partials/paymentFromNewCard.html',
                controller: 'PaymentFromNewCardCtrl',
                description: '/Billing'
            })
            .state(appRoutes.transactionComplete.state, {
                url: appRoutes.transactionComplete.route,
                templateUrl: '/billing/views/transactionComplete.html',
                controller: 'TransactionCompleteCtrl',
                description: '/Billing'
            })
            .state(appRoutes.paymentSummary.state, {
                url: appRoutes.paymentSummary.route,
                templateUrl: '/billing/views/paymentSummary.html',
                controller: 'PaymentSummaryCtrl',
                description: '/Billing',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Make A Payment'); }
                }
            })
            ///statements only routes///
            .state(appRoutes.paymentSummaryStatementsOnly.state, {
                url: appRoutes.paymentSummaryStatementsOnly.route,
                templateUrl: '/billing/views/paymentSummary.html',
                controller: 'PaymentSummaryCtrl',
                description: '/Billing',
                alternativeLoginRoute : true,
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Make A Payment'); }
                }
            })
            .state(appRoutes.paymentStatementsOnly.state, {
                url: appRoutes.paymentStatementsOnly.route,
                templateUrl: '/billing/views/paymentStatementsOnly.html',
                controller: 'BillingCtrl',
                description: '/Billing',
                alternativeLoginRoute : true
            })
            .state(appRoutes.paymentFromNewCardStatementsOnly.state, {
                url: appRoutes.paymentFromNewCardStatementsOnly.route,
                templateUrl: '/billing/views/partials/paymentFromNewCard.html',
                controller: 'PaymentFromNewCardCtrl',
                description: '/Billing',
                alternativeLoginRoute : true
            })
            .state(appRoutes.paymentOptionsStatementsOnly.state, {
                url: appRoutes.paymentOptionsStatementsOnly.route,
                templateUrl: '/billing/views/paymentOptions.html',
                controller: 'PaymentOptionsCtrl',
                description: '/Billing',
                alternativeLoginRoute : true,
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Make A Payment'); }
                }
            })
            .state(appRoutes.paymentFromConsentStatementsOnly.state, {
                url: appRoutes.paymentFromConsentStatementsOnly.route,
                templateUrl: '/billing/views/partials/paymentFromConsent.html',
                controller: 'PaymentFromConsentCtrl',
                description: '/Billing',
                alternativeLoginRoute : true
            })
        ;
    }]);